import { useEffect, useRef } from 'react';
import Chart from 'chart.js/auto';

function RadarChart() {
    const chartRef = useRef(null);
    const chartInstance = useRef(null);

    useEffect(() => {
        if (chartInstance.current) {
          chartInstance.current.destroy(); // Destruir gráfico
        }
    
        const ctx = chartRef.current.getContext('2d');
    
        chartInstance.current = new Chart(ctx, {
          type: 'radar',
          data: {
            labels: ['Esfuerzo', 'Habilidad', 'Fuerza', 'Resistencia', 'Velocidad'],
            datasets: [{
              label: 'Jugador 1',
              data: [80, 70, 90, 85, 75],
              borderColor: '#31d4be',
              backgroundColor: 'rgba(49, 212, 190, 0.2)',
              borderWidth: 2
            }, {
              label: 'Jugador 2',
              data: [85, 75, 95, 80, 70],
              borderColor: '#ff6384',
              backgroundColor: 'rgba(255, 99, 132, 0.2)',
              borderWidth: 2
            }]
          },
          options: {
            scales: {
              r: {
                beginAtZero: true
              }
            }
          }
        });

        return () => {
            if (chartInstance.current) {
              chartInstance.current.destroy();
            }
        };
    }, []);

    return (
      <canvas style={{width: '100%'}} ref={chartRef}></canvas>
    )
};

export default RadarChart;